<template>
  <v-card>
    <div class="d-flex justify-space-between align-center">
      <p class="ma-0 pl-2 pt-4 pb-1">Reporte de uso</p>
      <v-sheet max-width="170px">
        <v-select
          class="pa-0 ma-0"
          v-model="filterDateStatus"
          :items="filters"
          hide-details
          @change="changeFilterDate"
        ></v-select>
      </v-sheet>
    </div>
    <v-divider></v-divider>
    <v-container>
      <div v-if="showDatesSelected" class="d-flex align-center justify-end">
        {{ datesSelected.join(" ~ ") }}
        <v-btn x-small class="ma-0 ml-2" @click="showCalendar = true"
          >cambiar</v-btn
        >
      </div>
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <v-sheet max-width="120px">
            <v-select
              class="pa-0 ma-0"
              v-model="filterTypeSelected"
              :items="filterType"
              hide-details
            ></v-select>
          </v-sheet>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-center text-center mt-4"
          v-if="loadingAverage"
        >
          <v-progress-circular
            indeterminate
            size="50"
            color="primary"
          ></v-progress-circular>
        </v-col>
        <v-col class="pb-0 text-left" cols="6" v-if="!loadingAverage">
          <p class="text-subtitle-2">Usuario</p>
          <p
            class="text-subtitle-1 text--secondary ma-0"
            v-for="log in timeLogs"
            :key="log.uid + '-user'"
          >
            {{ log.name }}
          </p>
        </v-col>
        <v-col class="pb-0 text-right" cols="6" v-if="!loadingAverage">
          <div v-if="filterTypeSelected === 'Logs'">
            <p
              class="text-subtitle-2"
              @click="
                sortData('total', 1, -1);
                sortDataFilter = !sortDataFilter;
              "
              v-if="sortDataFilter"
            >
              Logs <v-icon>arrow_drop_up</v-icon>
            </p>
            <p
              class="text-subtitle-2"
              @click="
                sortData('total', -1, 1);
                sortDataFilter = !sortDataFilter;
              "
              v-else
            >
              Logs <v-icon>arrow_drop_down</v-icon>
            </p>
            <p
              class="text-subtitle-1 red--text ma-0"
              v-for="log in timeLogs"
              :key="log.uid + '-value'"
            >
              {{ log.total }}
            </p>
          </div>
          <div v-if="filterTypeSelected === 'Updates'">
            <p
              class="text-subtitle-2"
              @click="
                sortData('updates', 1, -1);
                sortDataFilter = !sortDataFilter;
              "
              v-if="sortDataFilter"
            >
              Updates <v-icon>arrow_drop_up</v-icon>
            </p>
            <p
              class="text-subtitle-2"
              @click="
                sortData('updates', -1, 1);
                sortDataFilter = !sortDataFilter;
              "
              v-else
            >
              Updates <v-icon>arrow_drop_down</v-icon>
            </p>
            <p
              class="text-subtitle-1 red--text ma-0"
              v-for="log in timeLogs"
              :key="log.uid + '-value'"
            >
              {{ log.updates }}
            </p>
          </div>
          <div v-if="filterTypeSelected === 'Tiempo en la app'">
            <p
              class="text-subtitle-2"
              @click="
                sortData('spend', 1, -1);
                sortDataFilter = !sortDataFilter;
              "
              v-if="sortDataFilter"
            >
              Minutos <v-icon>arrow_drop_up</v-icon>
            </p>
            <p
              class="text-subtitle-2"
              @click="
                sortData('spend', -1, 1);
                sortDataFilter = !sortDataFilter;
              "
              v-else
            >
              Minutos <v-icon>arrow_drop_down</v-icon>
            </p>
            <p
              class="text-subtitle-1 red--text ma-0"
              v-for="log in timeLogs"
              :key="log.uid + '-value'"
            >
              {{ log.spend | toMinutes }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showCalendar" max-width="300" persistent>
      <v-card>
        <div class="d-flex justify-end">
          <v-icon @click="closeCalendar" class="ml-2 mt-1">close</v-icon>
        </div>
        <v-container>
          <v-date-picker
            v-model="datesSelected"
            multiple
            :disabled="datesSelected.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelected.length < 2"
              @click="searchByDatesIncidence"
              >Aceptar</v-btn
            >
            <v-btn color="error" @click="resetDatesIncidence">Borrar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      sortDataFilter: true,
      filterDateStatus: "Todas",
      filters: ["Hoy", "Este mes", "Rango de fechas", "Todas"],
      filterType: ["Logs", "Updates", "Tiempo en la app"],

      filterTypeSelected: "Logs",
      loadingAverage: false,
      timeLogs: [],

      showCalendar: false,
      showDatesSelected: false,
      datesSelected: []
    };
  },
  computed: {
    ...mapState("user", ["data"])
  },
  async mounted() {
    this.loadingAverage = true;
    const query = {
      components: true,
      globalCheck: true
    };
    this.getCompletedData(query);
  },
  filters: {
    toMinutes(spent) {
      const spentToString = String(spent);
      const timeTransform = Number(
        spentToString.slice(0, spentToString.length - 5)
      );
      return timeTransform;
    }
  },
  methods: {
    ...mapActions("checklist", ["getUsageAnalytics"]),
    async getCompletedData(query) {
      try {
        const responseData = await this.getUsageAnalytics(query);
        this.timeLogs = responseData;
        this.sortData("updates", -1, 1);
        this.loadingAverage = false;
      } catch (error) {
        this.loadingAverage = false;
      }
    },
    async changeFilterDate(value) {
      switch (value) {
        case "Rango de fechas": {
          this.showCalendar = true;
          this.showDatesSelected = true;
          break;
        }
        case "Hoy": {
          this.loadingAverage = true;
          const query = {
            startAt: `${moment().format("YYYY-MM-DD")}`,
            components: true,
            endAt: `${moment()
              .add(1, "days")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(query);
          this.showDatesSelected = false;
          break;
        }
        case "Todas": {
          this.loadingAverage = true;
          const query = {
            components: true,
            globalCheck: true
          };
          this.getCompletedData(query);
          this.showDatesSelected = false;
          break;
        }
        case "Este mes": {
          this.loadingAverage = true;
          const queryMonth = {
            startAt: `${moment()
              .startOf("month")
              .format("YYYY-MM-DD")}`,
            components: true,
            endAt: `${moment()
              .endOf("month")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(queryMonth);
          this.showDatesSelected = false;
          break;
        }
      }
    },
    sortData(keySort, orderOne, orderTwo) {
      this.timeLogs.sort((a, b) => {
        if (a[keySort] > b[keySort]) {
          return orderOne;
        }
        if (a[keySort] < b[keySort]) {
          return orderTwo;
        }
        return 0;
      });
    },
    // calendar
    searchByDatesIncidence() {
      this.loadingAverage = true;
      const queryMonth = {
        components: true,
        startAt:
          this.datesSelected[0] < this.datesSelected[1]
            ? this.datesSelected[0]
            : this.datesSelected[1],
        endAt:
          this.datesSelected[1] > this.datesSelected[0]
            ? this.datesSelected[1]
            : this.datesSelected[0]
      };
      this.getCompletedData(queryMonth);
      this.showCalendar = false;
    },
    closeCalendar() {
      this.showCalendar = false;
      this.showDatesSelected = false;
      this.filterDateStatus = "Hoy";
      this.changeFilterDate("Hoy");
    },
    resetDatesIncidence() {
      this.datesSelected = [];
    }
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
</style>
